import { Tooltip } from "@mui/material";
import moment from "moment-timezone";

export const VirtualizedTableData = ({
    value,
    rightAlign,
    additionalData,
}: {
    value: string | number;
    rightAlign?: boolean;
    additionalData?: string;
}) => {
    const isPlaceholder =
      value?.toString()?.toLowerCase()?.includes('not available') ||
      value?.toString()?.toLowerCase()?.includes('match not found');
    return (
      <Tooltip title={isPlaceholder ? '' : value} placement="top">
        <div
          className={`max-w-[160px] ${
            rightAlign ? 'text-right' : 'text-left'
          } truncate ${
            isPlaceholder ? ' text-[#67676799]' : ''
          }`}
        >
          {value}
          {additionalData ? (
            <span className="text-[#67676799]"> {additionalData}</span>
          ) : null}
        </div>
      </Tooltip>
    );
};

export function VirtualizedTime({ time }: { time: Date | string }) {
    const _time = moment(time);
    const isPlaceholder = time === 'Data not available';
    return _time.isValid() && !isPlaceholder ? (
      <Tooltip title={_time.format('DD MMM YY, HH:mm:ss')} placement="top">
        <span className="max-w-[160px] truncate">{_time.format('DD MMM YY')}</span>
      </Tooltip>
    ) : (
      <VirtualizedTableData value={time.toString()} />
    );
}